export default class CardCarousel extends HTMLElement {
    constructor() {
        super();
    }
}

window.customElements.define('nc-card-carousel', CardCarousel);
